import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { CustomizedButton, CustomizedTypography } from '@components/Customized';
import { MuiBox, useCardStyle } from './styled';
import { IRequestPasswordForm } from './types';
import useClient from '@hooks/useClient';
import { STORAGE_ACTION } from '@utils/storage';
import * as assets from '@assets';
import {
  Container,
  Grid,
  Card,
  TextField,
  InputAdornment,
  IconButton
} from '@material-ui/core';
import { RemoveRedEye, VisibilityOff } from '@material-ui/icons';
import useUserActionLog from '@hooks/useUserActionLog';
import jwt from 'jsonwebtoken';

interface Props {
  onUpdate: (req: IRequestPasswordForm) => void;
}

const ResetPasswordPresenter: React.FC<Props> = ({ onUpdate }) => {
  const history = useHistory();
  const classes = useCardStyle();
  const { clientState } = useClient();
  const [isVisibilityPassword, setIsVisibilityPassword] = useState(false);
  const [isVisibilityNewPassword, setIsVisibilityNewPassword] = useState(false);
  const { register, handleSubmit, errors } = useForm<IRequestPasswordForm>();
  const { insertButtonLog } = useUserActionLog();
  const accessToken = localStorage.getItem('CLIENT_ACCESS_TOKEN');
  const DecodedAccessToken = accessToken
    ? JSON.parse(JSON.stringify(jwt.decode(accessToken)))
    : {};
  const DecodedaccessTokenEmail = DecodedAccessToken?.aud;

  const handleOnSubmit = (inputs: IRequestPasswordForm) => {
    onUpdate(inputs);
    localStorage.removeItem(STORAGE_ACTION.KEEP_LOGGED_IN);
  };

  const validationForm = {
    email: {
      required: { value: true, message: '이메일을 입력해 주세요.' },
      pattern: {
        value: /[-A-Za-z0-9_]+[-A-Za-z0-9_.]*[@]{1}[-A-Za-z0-9_]+[-A-Za-z0-9_.]*[.]{1}[A-Za-z]{1,5}/,
        message: '이메일 주소는 이메일 형식으로 입력해주세요.'
      }
    },
    password: {
      required: {
        value: true,
        message: '비밀번호를 입력해 주세요.'
      }
    },
    newPassword: {
      required: {
        value: true,
        message: '신규 비밀번호를 입력해 주세요.'
      },
      pattern: {
        value: /^(?=.*[a-zA-Z])(?=.*[0-9])(\W*).{8,}$/,
        message: '영문+숫자 혼용 8글자 이상으로 입력해주세요.'
      }
    }
  };

  return (
    <MuiBox>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        className={classes.logoRoot}
      >
        <img
          style={{ cursor: 'pointer' }}
          src={assets.LOGO_LARGE}
          width="125px"
          height="32px"
          alt=""
          onClick={() => history.push('/')}
        />
      </Grid>

      <Container maxWidth="xs">
        <Card
          elevation={0}
          className={classes.root}
          component="form"
          onSubmit={handleSubmit(handleOnSubmit)}
        >
          <CustomizedTypography
            className="title"
            variant="body1"
            align="center"
          >
            비밀번호 변경하기
          </CustomizedTypography>
          <TextField
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                input: classes.textfieldInputRoot
              }
            }}
            variant="outlined"
            disabled={true}
            defaultValue={clientState.email || DecodedaccessTokenEmail}
            size="small"
            fullWidth
          />
          <TextField
            type={isVisibilityPassword ? 'text' : 'password'}
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                input: classes.textfieldInputRoot
              },
              endAdornment: (
                <InputAdornment
                  className="remove-red-eye-icon"
                  position="end"
                  onClick={() => {
                    insertButtonLog(
                      'Button_Mypage_Update_ResetPassword_ShowPassword'
                    );
                    setIsVisibilityPassword((state) => !state);
                  }}
                >
                  <IconButton size="small" edge="end">
                    {isVisibilityPassword ? (
                      <RemoveRedEye />
                    ) : (
                      <VisibilityOff />
                    )}
                  </IconButton>
                </InputAdornment>
              )
            }}
            placeholder="현재 비밀번호"
            variant="outlined"
            autoComplete={'new-password'}
            error={errors.password ? true : false}
            helperText={errors.password && errors.password.message}
            inputProps={{
              name: 'password',
              ref: register(validationForm.password)
            }}
            size="small"
            fullWidth
          />
          <TextField
            type={isVisibilityNewPassword ? 'text' : 'password'}
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                input: classes.textfieldInputRoot
              },
              endAdornment: (
                <InputAdornment
                  className="remove-red-eye-icon"
                  position="end"
                  onClick={() => {
                    insertButtonLog(
                      'Button_Mypage_Update_ResetPassword_ShowPassword'
                    );
                    setIsVisibilityNewPassword((state) => !state);
                  }}
                >
                  <IconButton size="small" edge="end">
                    {isVisibilityNewPassword ? (
                      <RemoveRedEye />
                    ) : (
                      <VisibilityOff />
                    )}
                  </IconButton>
                </InputAdornment>
              )
            }}
            placeholder="신규 비밀번호 (영문, 숫자 조함 8자 이상)"
            variant="outlined"
            error={errors.newPassword ? true : false}
            helperText={errors.newPassword && errors.newPassword.message}
            inputProps={{
              name: 'newPassword',
              ref: register(validationForm.newPassword)
            }}
            size="small"
            fullWidth
          />
          <CustomizedButton
            className="submit-btn"
            type="submit"
            fullWidth
            color="primary"
            variant="contained"
            size="large"
            disableElevation
          >
            비밀번호 변경
          </CustomizedButton>
          <CustomizedTypography
            className="question-text"
            variant="body2"
            align="center"
            onClick={() => history.push('/login')}
          >
            로그인 화면 가기
          </CustomizedTypography>
        </Card>
      </Container>
    </MuiBox>
  );
};

export default ResetPasswordPresenter;
